<p-toast key="ajustement"></p-toast>

@if (!EstCharge()) {
  <p-card>
    <div class="fluid formgrid grid">
      <div class="flex flex-column gap-2 col-12 text-center">
        <p-progressSpinner></p-progressSpinner>
      </div>
    </div>
  </p-card>
}

@if (EstCharge()) {
  <div #contenu>
    <div class="col-12">
      <p-card>
        <div class="fluid formgrid grid">
          <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-4">
            <label for="dateNouvellesKms">Date</label>
            <p-calendar appendTo="body" showIcon="true" inputId="dateNouvellesKms" [(ngModel)]="heure.dateNouvellesKms" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
            @if (submitted && !heure.dateNouvellesKms) {
              <small class="p-error">La date est obligatoire.</small>
            }
          </div>

          <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-4">
            <label for="nbKms">Nb KM</label>
            <p-inputNumber #champNbHeures inputId="nbKms" [(ngModel)]="heure.kms" [min]="0" [placeholder]="heure.kmsActuelles || 0" (keyup.enter)="confirmer()"></p-inputNumber>
            @if (submitted && !heure.kms && heure.kms != 0) {
              <small class="p-error">Le nombre de KM est obligatoire.</small>
            }
          </div>
        </div>

        <div class="grid">
          <div class="col-12 flex justify-content-end gap-2 mt-3">
            <p-button label="Annuler" icon="pi pi-times" severity="secondary" [text]="true" (onClick)="annuler()" />
            <p-button label="Confirmer" icon="pi pi-save" (onClick)="confirmer()" />
          </div>
        </div>
      </p-card>
    </div>
  </div>
}
